import Swal from "sweetalert2";

const ERROR_CAP = 100;

const toErrorText = (value) => {
    if (value == null || value === "") {
        return "";
    }

    let text = value;
    if (typeof value !== "string") {
        try {
            text = JSON.stringify(value);
        } catch {
            text = String(value);
        }
    }

    return String(text).trim();
};

export const capErrorMessage = (value, maxLength = ERROR_CAP) => {
    const text = toErrorText(value);
    if (!text) {
        return "";
    }
    if (text.length <= maxLength) {
        return text;
    }
    return `${text.slice(0, maxLength).trimEnd()}…`;
};

export const showServerErrorAlert = (axiosError, customErrorMessage) => {
    const data = axiosError?.response?.data;
    const serverMessage =
        (typeof data?.message === "string" && data.message.trim()) || "";
    const fallbackMessage =
        (typeof axiosError?.message === "string" && axiosError.message.trim()) ||
        "Something went wrong!";

    const title = customErrorMessage?.title || "Error!";
    const text =
        (customErrorMessage?.message &&
            customErrorMessage.message !== "server" &&
            customErrorMessage.message) ||
        serverMessage ||
        fallbackMessage;

    const rawDetail = toErrorText(data?.error);
    const footer =
        rawDetail && rawDetail !== String(text).trim()
            ? capErrorMessage(rawDetail)
            : undefined;

    Swal.fire({
        icon: "error",
        title,
        text,
        ...(footer ? { footer } : {}),
    });
};
